import { atom } from "jotai";

export const SaleHistoryPageAtom = atom(1);
export const SaleHistoryPageSizeAtom = atom(10);
export const ProductSaleHistoryPageAtom = atom(1);
export const ProductSaleHistoryPageSizeAtom = atom(10);
